import './ChatRetentionEmptyNotice.css';

const DEFAULT_TITLE = 'チャットを始めましょう';
const DEFAULT_BODY = '';

export default function ChatRetentionEmptyNotice({
  title = DEFAULT_TITLE,
  body = DEFAULT_BODY,
  className = '',
}) {
  return (
    <div className={`chat-retention-empty ${className}`.trim()} role="status" aria-live="polite">
      <div className="chat-retention-empty__body">
        <p className="chat-retention-empty__title">{title}</p>
        {body ? <p className="chat-retention-empty__text">{body}</p> : null}
      </div>
    </div>
  );
}
